import React from "react";
import Routes from "./Routes";
import ReactDom from "react-dom";

ReactDom.render(<Routes />, document.getElementById("root"));

